// This file is auto-generated by scripts/generate-icon-imports.mjs
// Do not edit manually. Run 'pnpm run generate:icons' to regenerate.

import type { StaticImageData } from "next/image";

import Active247 from "@public/icons/active/247_active.png";
import ActiveAcute from "@public/icons/active/acute_active.png";
import ActiveApiCog from "@public/icons/active/apiCog_active.png";
import ActiveApi from "@public/icons/active/api_active.png";
import ActiveAssetsTrading from "@public/icons/active/assetsTrading_active.png";
import ActiveBalance from "@public/icons/active/balance_active.png";
import ActiveBrick from "@public/icons/active/brick_active.png";
import ActiveCandlestickChart from "@public/icons/active/candlestickChart_active.png";
import ActiveConnectHub from "@public/icons/active/connectHub_active.png";
import ActiveDonutLarge from "@public/icons/active/donutLarge_active.png";
import ActiveDonutSmall from "@public/icons/active/donutSmall_active.png";
import ActiveFastForward from "@public/icons/active/fastForward_active.png";
import ActiveGavel from "@public/icons/active/gavel_active.png";
import ActiveGlobal from "@public/icons/active/global_active.png";
import ActiveGroup from "@public/icons/active/group_active.png";
import ActiveHubCrosschain from "@public/icons/active/hubCrosschain_active.png";
import ActiveInclusiveAccess from "@public/icons/active/inclusiveAccess_active.png";
import ActiveIncrease1 from "@public/icons/active/increase1_active.png";
import ActiveInvestors from "@public/icons/active/investors_active.png";
import ActiveKey from "@public/icons/active/key_active.png";
import ActiveLayers from "@public/icons/active/layers_active.png";
import ActiveLightBulb from "@public/icons/active/lightBulb_active.png";
import ActiveLocalLibrary from "@public/icons/active/localLibrary_active.png";
import ActivePersonShield from "@public/icons/active/personShield_active.png";
import ActivePublic from "@public/icons/active/public_active.png";
import ActiveRocket from "@public/icons/active/rocket_active.png";
import ActiveSecurity from "@public/icons/active/security_active.png";
import ActiveSercurity from "@public/icons/active/sercurity_active.png";
import ActiveToken from "@public/icons/active/token_active.png";
import ActiveTrade from "@public/icons/active/trade_active.png";
import ActiveVerifiedInstitution from "@public/icons/active/verifiedInstitution_active.png";
import ActiveVerifiedService from "@public/icons/active/verifiedService_active.png";
import ActiveVerifiedUsers from "@public/icons/active/verifiedUsers_active.png";
import ActiveVisibility from "@public/icons/active/visibility_active.png";
import ActiveWhatShot from "@public/icons/active/whatShot_active.png";
import ActiveWidget from "@public/icons/active/widget_active.png";
import Deafult247 from "@public/icons/deafult/247.png";
import DeafultAcute from "@public/icons/deafult/acute.png";
import DeafultApi from "@public/icons/deafult/api.png";
import DeafultApiCog from "@public/icons/deafult/apiCog.png";
import DeafultAssetsTrading from "@public/icons/deafult/assetsTrading.png";
import DeafultBadge from "@public/icons/deafult/badge.png";
import DeafultBalance from "@public/icons/deafult/balance.png";
import DeafultBarCharts from "@public/icons/deafult/barCharts.png";
import DeafultBrick from "@public/icons/deafult/brick.png";
import DeafultBusiness from "@public/icons/deafult/business.png";
import DeafultCandleStickCharts from "@public/icons/deafult/candleStickCharts.png";
import DeafultChartIncrease from "@public/icons/deafult/chartIncrease.png";
import DeafultConnect from "@public/icons/deafult/connect.png";
import DeafultConnectHub from "@public/icons/deafult/connectHub.png";
import DeafultDonutLarge from "@public/icons/deafult/donutLarge.png";
import DeafultDonutSmall from "@public/icons/deafult/donutSmall.png";
import DeafultFastForward from "@public/icons/deafult/fastForward.png";
import DeafultGavel from "@public/icons/deafult/gavel.png";
import DeafultGlobal from "@public/icons/deafult/global.png";
import DeafultGroup from "@public/icons/deafult/group.png";
import DeafultHandShake from "@public/icons/deafult/handShake.png";
import DeafultHubCrosschain from "@public/icons/deafult/hubCrosschain.png";
import DeafultInclusiveAccess from "@public/icons/deafult/inclusiveAccess.png";
import DeafultIncrease1 from "@public/icons/deafult/increase1.png";
import DeafultInstitution from "@public/icons/deafult/institution.png";
import DeafultInvestors from "@public/icons/deafult/investors.png";
import DeafultKey from "@public/icons/deafult/key.png";
import DeafultLayers from "@public/icons/deafult/layers.png";
import DeafultLightBulb from "@public/icons/deafult/lightBulb.png";
import DeafultLocalLibrary from "@public/icons/deafult/localLibrary.png";
import DeafultPersonShield from "@public/icons/deafult/personShield.png";
import DeafultPublic from "@public/icons/deafult/public.png";
import DeafultRocket from "@public/icons/deafult/rocket.png";
import DeafultSecurity from "@public/icons/deafult/security.png";
import DeafultSercurity from "@public/icons/deafult/sercurity.png";
import DeafultServices from "@public/icons/deafult/services.png";
import DeafultToken from "@public/icons/deafult/token.png";
import DeafultTrade from "@public/icons/deafult/trade.png";
import DeafultVerifiedInstitution from "@public/icons/deafult/verifiedInstitution.png";
import DeafultVerifiedService from "@public/icons/deafult/verifiedService.png";
import DeafultVerifiedUsers from "@public/icons/deafult/verifiedUsers.png";
import DeafultVisibility from "@public/icons/deafult/visibility.png";
import DeafultWallet from "@public/icons/deafult/wallet.png";
import DeafultWhatShot from "@public/icons/deafult/whatShot.png";
import DeafultWidget from "@public/icons/deafult/widget.png";

export const iconImageMap = {
  Active247: Active247,
  ActiveAcute: ActiveAcute,
  ActiveApiCog: ActiveApiCog,
  ActiveApi: ActiveApi,
  ActiveAssetsTrading: ActiveAssetsTrading,
  ActiveBalance: ActiveBalance,
  ActiveBrick: ActiveBrick,
  ActiveCandlestickChart: ActiveCandlestickChart,
  ActiveConnectHub: ActiveConnectHub,
  ActiveDonutLarge: ActiveDonutLarge,
  ActiveDonutSmall: ActiveDonutSmall,
  ActiveFastForward: ActiveFastForward,
  ActiveGavel: ActiveGavel,
  ActiveGlobal: ActiveGlobal,
  ActiveGroup: ActiveGroup,
  ActiveHubCrosschain: ActiveHubCrosschain,
  ActiveInclusiveAccess: ActiveInclusiveAccess,
  ActiveIncrease1: ActiveIncrease1,
  ActiveInvestors: ActiveInvestors,
  ActiveKey: ActiveKey,
  ActiveLayers: ActiveLayers,
  ActiveLightBulb: ActiveLightBulb,
  ActiveLocalLibrary: ActiveLocalLibrary,
  ActivePersonShield: ActivePersonShield,
  ActivePublic: ActivePublic,
  ActiveRocket: ActiveRocket,
  ActiveSecurity: ActiveSecurity,
  ActiveSercurity: ActiveSercurity,
  ActiveToken: ActiveToken,
  ActiveTrade: ActiveTrade,
  ActiveVerifiedInstitution: ActiveVerifiedInstitution,
  ActiveVerifiedService: ActiveVerifiedService,
  ActiveVerifiedUsers: ActiveVerifiedUsers,
  ActiveVisibility: ActiveVisibility,
  ActiveWhatShot: ActiveWhatShot,
  ActiveWidget: ActiveWidget,
  Deafult247: Deafult247,
  DeafultAcute: DeafultAcute,
  DeafultApi: DeafultApi,
  DeafultApiCog: DeafultApiCog,
  DeafultAssetsTrading: DeafultAssetsTrading,
  DeafultBadge: DeafultBadge,
  DeafultBalance: DeafultBalance,
  DeafultBarCharts: DeafultBarCharts,
  DeafultBrick: DeafultBrick,
  DeafultBusiness: DeafultBusiness,
  DeafultCandleStickCharts: DeafultCandleStickCharts,
  DeafultChartIncrease: DeafultChartIncrease,
  DeafultConnect: DeafultConnect,
  DeafultConnectHub: DeafultConnectHub,
  DeafultDonutLarge: DeafultDonutLarge,
  DeafultDonutSmall: DeafultDonutSmall,
  DeafultFastForward: DeafultFastForward,
  DeafultGavel: DeafultGavel,
  DeafultGlobal: DeafultGlobal,
  DeafultGroup: DeafultGroup,
  DeafultHandShake: DeafultHandShake,
  DeafultHubCrosschain: DeafultHubCrosschain,
  DeafultInclusiveAccess: DeafultInclusiveAccess,
  DeafultIncrease1: DeafultIncrease1,
  DeafultInstitution: DeafultInstitution,
  DeafultInvestors: DeafultInvestors,
  DeafultKey: DeafultKey,
  DeafultLayers: DeafultLayers,
  DeafultLightBulb: DeafultLightBulb,
  DeafultLocalLibrary: DeafultLocalLibrary,
  DeafultPersonShield: DeafultPersonShield,
  DeafultPublic: DeafultPublic,
  DeafultRocket: DeafultRocket,
  DeafultSecurity: DeafultSecurity,
  DeafultSercurity: DeafultSercurity,
  DeafultServices: DeafultServices,
  DeafultToken: DeafultToken,
  DeafultTrade: DeafultTrade,
  DeafultVerifiedInstitution: DeafultVerifiedInstitution,
  DeafultVerifiedService: DeafultVerifiedService,
  DeafultVerifiedUsers: DeafultVerifiedUsers,
  DeafultVisibility: DeafultVisibility,
  DeafultWallet: DeafultWallet,
  DeafultWhatShot: DeafultWhatShot,
  DeafultWidget: DeafultWidget,
} as const satisfies Record<string, StaticImageData>;

export type IconImageName = keyof typeof iconImageMap;
